import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

export type SignUpAuthenticationMethod = 'jusbrasil_form' | 'google_authentication'

export interface GA4SignUpEventProps {
  authentication_method: SignUpAuthenticationMethod
  successful_attempt: boolean
}

export class GA4SignUpEvent extends GA4Event {
  authentication_method: GA4SignUpEventProps['authentication_method']
  successful_attempt: GA4SignUpEventProps['successful_attempt']

  constructor({ authentication_method, successful_attempt }: GA4SignUpEventProps) {
    super({ event: EVENT.SIGN_UP })

    this.authentication_method = authentication_method
    this.successful_attempt = successful_attempt
  }
}
